import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

import type { AddedWidgetConfig, RouteConfiguration } from '../../types';
import { log } from '../services/monitor';
import { getRoutes, updateRoutesConfig } from './controllers-routes';

const logEmptyRoutesOverride = (
  newRoutes: RouteConfiguration[],
  oldRoutes: RouteConfiguration[],
) => {
  if (!newRoutes || !newRoutes.length) {
    log('MAV2 (addRoutesInAppProperties): Routes data is empty', {
      extra: {
        newRoutes,
        oldRoutes,
      },
    });
  }
};

const getIsRouteAlreadyAdded = (
  currentRoutes: RouteConfiguration[] | undefined,
  newPath: string,
  newState: string,
) =>
  !!currentRoutes?.some(
    ({ path, state }) => path === newPath || state === newState,
  );

const getNewRoutes = (
  currentRoutes: RouteConfiguration[] | undefined,
  addedWidgetsConfigs: AddedWidgetConfig[],
) => {
  return addedWidgetsConfigs.reduce<RouteConfiguration[]>(
    (previousValue, currentValue) => {
      if (!currentValue.state) {
        return previousValue;
      }

      const isRouteAlreadyAdded = getIsRouteAlreadyAdded(
        currentRoutes,
        currentValue.path,
        currentValue.state,
      );

      if (isRouteAlreadyAdded) {
        return previousValue;
      }

      // TODO: don't save values which has default values to save space
      previousValue.push({
        path: currentValue.path,
        state: currentValue.state,
        vfr: currentValue.vfr,
        home: currentValue.home,
        private: currentValue.private,
        widgetId: currentValue.widgetId,
      });

      return previousValue;
    },
    currentRoutes ?? [],
  );
};

export const addRoutesInAppProperties = async (
  editorSDK: FlowEditorSDK,
  addedWidgetsConfigs: AddedWidgetConfig[],
) => {
  const currentRoutes = await getRoutes(editorSDK);

  const newRoutes = getNewRoutes(currentRoutes, addedWidgetsConfigs);

  const updatedRoutes = newRoutes ?? currentRoutes ?? [];

  logEmptyRoutesOverride(updatedRoutes, currentRoutes);

  return updateRoutesConfig(editorSDK, updatedRoutes);
};
